module.exports = __webpack_public_path__ + "media/images/flags/sb-6c301d55ae5fced9aecb48dd72eab4ca.svg";